import React from "react";

export const NoMatch = () => (
  <h1>Sorry ! The page you are looking for not found.</h1>
);
